import config from '@/config'
import lang from '@/lang'

const miteResourceUrl = `${config.resourceHost}mite`

export default {
  endpoints: {
    entries: appId => `${miteResourceUrl}/${appId}/time_entries`,
    lockItem: (appId, id) => `${miteResourceUrl}/${appId}/time_entry/${id}`,
  },
  filters: [
    {
      name: 'all',
      title: lang.mite.filter.all,
      quickFilter: null,
    },
    {
      name: 'locked',
      title: lang.mite.filter.cleared,
      quickFilter: {
        locked: {
          type: 'set',
          values: [lang.mite.lockedStatus.true],
        },
      },
    },
    {
      name: 'unlocked',
      title: lang.mite.filter.notCleared,
      quickFilter: {
        locked: {
          type: 'set',
          values: [lang.mite.lockedStatus.false],
        },
      },
    },
  ],
  columns: [
    {
      headerName: lang.mite.columns.date,
      field: 'createdAt',
      cellClass: 'ag-custom-first',
      cellRenderer: 'dateCellRenderer',
    },
    { headerName: lang.mite.columns.customer, field: 'customerName' },
    { headerName: lang.mite.columns.project, field: 'projectName' },
    { headerName: lang.mite.columns.service, field: 'serviceName' },
    { headerName: lang.mite.columns.note, field: 'note' },
    { headerName: lang.mite.columns.hours, field: 'hours' },
    { headerName: lang.mite.columns.revenue, field: 'revenue', cellRenderer: 'currencyAmountCellRenderer' },
    { headerName: lang.mite.columns.cleared, field: 'locked', filter: true },
  ],
}
